// extracted by mini-css-extract-plugin
export default {"root":"LabNotesContainer_root__oiTJ8","formTitle":"LabNotesContainer_formTitle__CYhM0","main":"LabNotesContainer_main__38gtQ","tableWrap":"LabNotesContainer_tableWrap__nOHYC"};